<div class="menu-container" #menuContainer>
	<div class="abrirMenu">
		<p>
			<fa-icon [icon]="faBars" #abrirButton (click)="abrirMenu()"></fa-icon>
		</p>
	</div>
	<div class="menuExtra" id="menu" #menuOffCanvas>
		<div class="cerrarMenu">
			<p>
				<fa-icon [icon]="faTimesCircle" #cerrarButton (click)="abrirMenu()"></fa-icon>
			</p>
		</div>
		<div class="extra" #extra>
			<div class="covid">
				<fa-icon [icon]="faVirus"></fa-icon>
				<h1>COVID-19</h1>
			</div>
			<div class="contacto-header">
				<h1>Central de Atendimento: <a href=""> (11) 3333-4444</a></h1>
				<h1><a [routerLink]="['../login']">
					<fa-icon [icon]="faUserAlt"></fa-icon> Clinica Online</a></h1>
			</div>
		</div>
		<div class="menu" #menu>
			<nav>
				<ul>
					<li><a href="" [routerLink]="['./home']"><fa-icon [icon]="faHome"></fa-icon></a></li>
					<li><a href="">Especialidades</a></li>
					<li><a href="" [routerLink]="['../doctores']">Equipe Médica</a></li>
					<li><a href="">Contato</a></li>
					<li><a href="" class="cita" [routerLink]="['../login']">Agendar Consulta</a></li>
				</ul>
			</nav>
		</div>
	</div>
	<div class="logo-container" #logoContainer>
		<figure class="logo">
			<img src="./../../assets/img/logo-life.png" alt="logo" #logo>
		</figure>
	</div>
</div>

<!-- FIN MENU -->

<!-- INICIO HEADER -->

<header class="header">
	<div class="header1 headers" #headers></div>
	<div class="header2 headers" style="visibility: hidden; opacity: 0"#headers></div>
	<div class="header3 headers" style="visibility: hidden; opacity: 0"#headers></div>
</header>

<!-- FIN HEADER -->

<!-- INICIO ESPECIALIDADES -->

<section class="especialidades-container">
	<h1>Nossas especialidades</h1>
	<div class="especialidades">
		<div class="especialidades-card">
			<a href="">
				<div class="subtitulo">
					<h2>Especialidades</h2>
				</div>
				<div class="central cardiologia">
					<figure>
						<img src="./../../assets/img/cardioIcon.png" alt="">
					</figure>
					<h1>Cardiologia</h1>
				</div>
				<div class="enlace">Ver mais <fa-icon [icon]="faChevronCircleRight"></fa-icon></div>
			</a>
		</div>
		<div class="especialidades-card">
			<a href="">
				<div class="subtitulo">
					<h2>Especialidades</h2>
				</div>
				<div class="central">
					<figure>
						<img src="./../../assets/img/cancerIcon.png" alt="">
					</figure>
					<h1>Oncologia</h1>
				</div>
				<div class="enlace">Ver mais <fa-icon [icon]="faChevronCircleRight"></fa-icon></div>
			</a>
		</div>
		<div class="especialidades-card">
			<a href="">
				<div class="subtitulo">
					<h2>Especialidades</h2>
				</div>
				<div class="central">
					<figure>
						<img src="./../../assets/img/stomatchIcon.png" alt="">
					</figure>
					<h1>Gastroenterologia</h1>
				</div>
				<div class="enlace">Ver mais <fa-icon [icon]="faChevronCircleRight"></fa-icon></div>
			</a>
		</div>
		<div class="especialidades-card">
			<a href="">
				<div class="subtitulo">
					<h2>Especialidades</h2>
				</div>
				<div class="central">
					<figure>
						<img src="./../../assets/img/ginecoIcon.png" alt="">
					</figure>
					<h1>Ginecologia</h1>
				</div>
				<div class="enlace">Ver mais <fa-icon [icon]="faChevronCircleRight"></fa-icon></div>
			</a>
		</div>
		<div class="especialidades-card">
			<a href="">
				<div class="subtitulo">
					<h2>Especialidades</h2>
				</div>
				<div class="central">
					<figure>
						<img src="./../../assets/img/pediatriaIcon.png" alt="">
					</figure>
					<h1>Pediatria</h1>
				</div>
				<div class="enlace">Ver mais <fa-icon [icon]="faChevronCircleRight"></fa-icon></div>
			</a>
		</div>
	</div>
	<a href="">
		<div class="masEspe">
			<h2>Veja mais especialidades <fa-icon [icon]="faChevronCircleRight"></fa-icon></h2>
		</div>
	</a>
</section>

<!-- FIN ESPECIALIDADES -->

<!-- INICIO STAFF -->

<section class="staff-container">
	<h1>Nossa equipe</h1>
	<div class="staff-group">
		<div class="responStaff">
			<a href="" [routerLink]="['../doctores']">
				<div class="staff">
					<div class="info">
						<div class="arriba">
							<h2>Oftalmologia</h2>
						</div>
						<div class="medio">
							<h1>Dr. Luiz Santos</h1>
							<p>Dr. em chefe de Oftalmologia</p>
						</div>
						<div class="abajo">
							<p>Saber mais <fa-icon [icon]="faChevronCircleRight"></fa-icon></p>
						</div>
					</div>
					<figure><img src="./../../assets/img/doctores/6.jpg" alt=""></figure>
				</div>
			</a>
			<a href="" [routerLink]="['../doctores']">
				<div class="staff">
					<div class="info">
						<div class="arriba">
							<h2>Ginecologia</h2>
						</div>
						<div class="medio">
							<h1>Dra. Ana Gomes</h1>
							<p>Dra. em chefe de Ginecologia</p>
						</div>
						<div class="abajo">
							<p>Conoce más <fa-icon [icon]="faChevronCircleRight"></fa-icon></p>
						</div>
					</div>
					<figure><img src="./../../assets/img/doctores/2.jpg" alt=""></figure>
				</div>
			</a>
		</div>
		<div class="responStaff">
			<a href="" [routerLink]="['../doctores']">
				<div class="staff">
					<div class="info">
						<div class="arriba">
							<h2>Dermatologia</h2>
						</div>
						<div class="medio">
							<h1>Dr. Lucas Ferreira</h1>
							<p>Dr. em chefe de Dermatologia</p>
						</div>
						<div class="abajo">
							<p>Saber mais <fa-icon [icon]="faChevronCircleRight"></fa-icon></p>
						</div>
					</div>
					<figure><img src="./../../assets/img/doctores/1.jpg" alt=""></figure>
				</div>
			</a>
			<a href="" [routerLink]="['../doctores']">
				<div class="staff">
					<div class="info">
						<div class="arriba">
							<h2>Pediatria</h2>
						</div>
						<div class="medio">
							<h1>Dr. João Silva</h1>
							<p>Dr. em chefe de Pediatria</p>
						</div>
						<div class="abajo">
							<p>Saber mais <fa-icon [icon]="faChevronCircleRight"></fa-icon></p>
						</div>
					</div>
					<figure><img src="./../../assets/img//doctores/3.jpg" alt=""></figure>
				</div>
			</a>
		</div>

	</div>
	<a href=""[routerLink]="['../doctores']" style="text-decoration: none;" >
		<div class="masDoc">
			<h1>Conheça toda nossa equipe <fa-icon [icon]="faChevronCircleRight"></fa-icon></h1>
		</div>
	</a>

</section>

<!-- FIN STAFF -->

<!-- INICIO FOOTER -->

<footer class="footer-container">
	<div class="footer-main" #footerMain>
		<div class="footer-left">
			<img src="./../../assets/img/logo-life.png" alt="Logo">
			<p>© 2022 Clínica Life</p>
		</div>
		<div class="footer-info" #footerInfo>
			<h2 class="footer-title">Mais informação</h2>
			<ul>
				<li>
					<a href="#">Sobre nós</a>
				</li>
				<li>
					<a href="#">Nossas especialidades</a>
				</li>
				<li>
					<a href="#">Nossa equipe médica</a>
				</li>
			</ul>
		</div>
		<div class="footer-contact" #footerContact>
			<h2 class="footer-title">Contate-Nos</h2>
			<form action="">
				<input class="input" type="email" name="email" id="email" placeholder="Correio eletrônico">
				<input class="button" type="submit" value="Enviar">
			</form>
		</div>
	</div>
</footer>